import { useState, useEffect } from 'react';
import { storage } from '../utils/storage';

export const useTheme = () => {
  const [theme, setTheme] = useState('light');
  const [fontSize, setFontSize] = useState('normal');

  useEffect(() => {
    const savedTheme = storage.get('theme') || 'light';
    const savedFontSize = storage.get('fontSize') || 'normal';
    setTheme(savedTheme);
    setFontSize(savedFontSize);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    storage.set('theme', newTheme);
  };

  return { theme, toggleTheme, fontSize, setFontSize };
};